/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Display_Name_HelpInputs */

const en_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The name that will be displayed for this group`)
};

const fr_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom qui sera affiché pour ce groupe`)
};

const de_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Name, der für diese Gruppe angezeigt wird`)
};

const it_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nome che verrà visualizzato per questo gruppo`)
};

const ru_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название, которое будет отображаться для этой группы.`)
};

const es_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre que se mostrará para este grupo`)
};

const zh_cn2_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此组将显示的名称`)
};

const ja_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このグループに表示される名前`)
};

const hi_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस समूह के लिए प्रदर्शित होने वाला नाम`)
};

const pt_pt2_edit_event_group_display_name_help = /** @type {(inputs: Edit_Event_Group_Display_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome que será exibido para este grupo`)
};

/**
* | output |
* | --- |
* | "The name that will be displayed for this group" |
*
* @param {Edit_Event_Group_Display_Name_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_display_name_help = /** @type {((inputs?: Edit_Event_Group_Display_Name_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Display_Name_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_display_name_help(inputs)
	if (locale === "de") return de_edit_event_group_display_name_help(inputs)
	if (locale === "it") return it_edit_event_group_display_name_help(inputs)
	if (locale === "ru") return ru_edit_event_group_display_name_help(inputs)
	if (locale === "es") return es_edit_event_group_display_name_help(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_display_name_help(inputs)
	if (locale === "ja") return ja_edit_event_group_display_name_help(inputs)
	if (locale === "hi") return hi_edit_event_group_display_name_help(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_display_name_help(inputs)
	return en_edit_event_group_display_name_help(inputs)
});